/* Illustrative landing-page demo; no generation or customer data requests. */
if (!customElements.get('aic-hero-animation')) {
  customElements.define('aic-hero-animation', class extends HTMLElement {
    connectedCallback() {
      this.elapsed = 0;
      this.visible = false;
      this.paused = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.copy = this.querySelector('.aic-demo__typed');
      this.prompt = this.copy.textContent;
      this.button = this.querySelector('button');
      this.status = this.querySelector('.aic-demo__status');
      this.step = this.querySelector('.aic-demo__step');
      this.colours = ['black', 'white', 'red', 'beige', 'navy', 'green', 'lavender'];
      this.shirts = this.querySelectorAll('[data-shirt-colour]');
      this.swatches = this.querySelectorAll('.aic-demo__swatch');
      this.colourName = this.querySelector('.aic-demo__colour-name');
      this.onToggle = () => { this.paused = !this.paused; this.sync(); };
      this.onVisibility = () => this.sync();
      this.onMotion = () => { this.paused = this.motion.matches; this.elapsed = this.paused ? 7000 : 0; this.render(); this.sync(); };
      this.button.addEventListener('click', this.onToggle);
      this.motion.addEventListener('change', this.onMotion);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.observer = new IntersectionObserver(([entry]) => { this.visible = entry.isIntersecting; this.sync(); });
      this.observer.observe(this);
      this.onMotion();
    }
    sync() {
      cancelAnimationFrame(this.frame);
      this.last = null;
      this.toggleAttribute('data-paused', this.paused);
      this.button.textContent = this.paused ? 'Play' : 'Pause';
      this.button.setAttribute('aria-label', `${this.paused ? 'Play' : 'Pause'} design animation`);
      if (this.visible && !document.hidden && !this.paused) this.frame = requestAnimationFrame(time => this.tick(time));
    }
    tick(time) {
      if (this.last !== null) this.elapsed = (this.elapsed + time - this.last) % 13900;
      this.last = time;
      this.render();
      this.frame = requestAnimationFrame(next => this.tick(next));
    }
    render() {
      const t = this.elapsed;
      const stage = t < 4200 ? 'chat' : t < 5600 ? 'loading' : t < 6200 ? 'artwork' : 'ready';
      const beat = t < 1800 ? 'typing' : t < 2300 ? 'sent' : t < 3600 ? 'reply' : t < 4200 ? 'confirm' : 'loading';
      const colour = this.colours[Math.min(6, Math.floor(Math.max(0, t - 6200) / 1100))];
      this.dataset.stage = stage;
      this.dataset.beat = beat;
      if (this.dataset.colour !== colour) {
        this.dataset.colour = colour;
        this.shirts.forEach(image => image.toggleAttribute('data-active', image.dataset.shirtColour === colour));
        this.swatches.forEach(swatch => swatch.toggleAttribute('data-active', swatch.dataset.colour === colour));
      }
      const text = beat === 'typing' ? this.prompt.slice(0, Math.floor(Math.max(0, t - 200) / 26)) : 'Reply…';
      if (this.copy.textContent !== text) this.copy.textContent = text;
      this.style.setProperty('--demo-scan', Math.max(0, (t - 4200) % 700) / 700);
      this.status.textContent = stage === 'artwork' ? 'Your design is ready' : t < 6200 ? 'Now on your T-shirt' : 'Pick your colour';
      this.step.textContent = t < 6200 ? '02 / From photo to print' : '03 / Make it yours';
      this.colourName.textContent = colour[0].toUpperCase() + colour.slice(1);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.observer.disconnect();
      this.button.removeEventListener('click', this.onToggle);
      this.motion.removeEventListener('change', this.onMotion);
      document.removeEventListener('visibilitychange', this.onVisibility);
    }
  });
}
